import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RetailerTransactionStatementsModel} from './retailer-transaction-statements.model';
import {Observable} from 'rxjs';
import {environment} from "@env/environment";


@Injectable({providedIn: 'root'})
export class RetailerTransactionStatementsService {
  constructor(private http: HttpClient) {
  }

  get getBaseUrl(): string {
    return environment.apiTransactHost + `/admin/offering`;
  }

  loadStatements(params: { name: string, val: any }[]): Observable<RetailerTransactionStatementsModel[]> {
    let requestParams = new HttpParams();
    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {
        requestParams = requestParams.append(ea.name, ea.val)
      });
    }

    return this.http.get<RetailerTransactionStatementsModel[]>(this.getBaseUrl + `/transactions/summary`, {params: requestParams})
  }
}
